import { ChevronDown, ChevronUp, Archive } from "lucide-react";
import { chatRowClasses } from "./chatUtils";

const ChatArchivedList = ({
  conversations,
  expanded,
  currentTeamId,
  onToggle,
  onSelect,
}) => {
  if (conversations.length === 0) return null;

  return (
    <>
      <button
        onClick={() => onToggle("archived")}
        className="w-full flex items-center gap-x-1.5 px-2 py-1 text-[10px] uppercase tracking-wider text-zinc-400 dark:text-zinc-600 hover:text-zinc-500 dark:hover:text-zinc-500 transition-colors mt-1"
      >
        <span className="flex-1 text-left">Archived</span>
        {expanded ? (
          <ChevronUp className="h-2.5 w-2.5 shrink-0" strokeWidth={2} />
        ) : (
          <ChevronDown className="h-2.5 w-2.5 shrink-0" strokeWidth={2} />
        )}
      </button>
      {expanded &&
        conversations.map((conv) => {
          const isActive = conv.team_id === currentTeamId;
          const label =
            conv.name || conv.dm_display_name || "Conversation";
          return (
            <div
              key={conv.team_id}
              data-context-menu="team-conversation"
              data-context-payload={JSON.stringify({
                team_id: conv.team_id,
                type: conv.type || "group",
                name: label,
              })}
            >
              <button
                onClick={() => onSelect(conv.team_id)}
                title={label}
                className={[
                  "w-full text-left rounded-md px-2 py-1.5 text-[12px] truncate transition-colors flex items-center gap-x-1.5",
                  isActive
                    ? "text-[#0EA5E9] bg-[#0EA5E9]/[0.08] font-medium"
                    : "text-zinc-400 dark:text-zinc-600 hover:text-zinc-500 dark:hover:text-zinc-500 hover:bg-zinc-50 dark:hover:bg-zinc-800/40",
                ].join(" ")}
              >
                <Archive
                  className="h-3 w-3 shrink-0 text-zinc-400"
                  strokeWidth={2}
                />
                <span className="truncate">{label}</span>
              </button>
            </div>
          );
        })}
    </>
  );
};

export default ChatArchivedList;
